<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>

        <div class="footer" v-show="!$route.meta.fullScreen"></div>

        <TyTab v-if="!$route.meta.fullScreen"/>

    </div>
</template>

<script>
    import TyTab from '@/core/component/TyTab/TyTab'

    export default {
        components: {
            TyTab,
        },
    }
</script>

<style>
    html {
        height: 100%;
        width: 100%;
    }

    body {
        height: 100%;
        width: 100%;
        font-family: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB', 'Heiti SC', sans-serif;
        -webkit-font-smoothing: antialiased;
    }

    .footer {
        text-align: center;
        font-size: 12px;
        padding: 1em 0;
        color: #969696;
        clear: both;
        /*padding-bottom: 70px;*/
        padding-bottom: 45px;
    }

    .copyright {
        padding: 15px;
        text-align: center;
        font-size: 14px;
        color: #6d6d6d;
    }
</style>
